var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-td",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000067",
    d: "M0 0h171.2v512H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M340.8 0H512v512H340.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M171.2 0h169.6v512H171.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTd);
export default __webpack_public_path__ + "static/media/td.4feeb753a9cd1dfbaf01a6b661c9efce.svg";
export { ForwardRef as ReactComponent };